"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MozartArc = void 0;
var ethers_1 = require("ethers");
var core_1 = require("../arc-types/core");
var calculations_1 = require("./utils/calculations");
var asyncForEach_1 = require("./utils/asyncForEach");
var MozartCoreV1Factory_1 = require("./typings/MozartCoreV1Factory");
var IOracleFactory_1 = require("./typings/IOracleFactory");
var SyntheticTokenV1Factory_1 = require("./typings/SyntheticTokenV1Factory");
var TestTokenFactory_1 = require("./typings/TestTokenFactory");
var constants_1 = require("@ethersproject/constants");
var ArcNumber_1 = __importDefault(require("./utils/ArcNumber"));
var approve_1 = require("./utils/approve");
var MozartArc = /** @class */ (function () {
    function MozartArc() {
        this.synths = {};
    }
    MozartArc.init = function (signer) {
        return __awaiter(this, void 0, void 0, function () {
            var arc, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        arc = new MozartArc();
                        arc.signer = signer;
                        _a = arc;
                        return [4 /*yield*/, signer.getAddress()];
                    case 1:
                        _a.signerAddress = _b.sent();
                        return [2 /*return*/, arc];
                }
            });
        });
    };
    MozartArc.prototype.addSynths = function (synths) {
        return __awaiter(this, void 0, void 0, function () {
            var entries;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        entries = Object.entries(synths);
                        return [4 /*yield*/, asyncForEach_1.asyncForEach(entries, function (_a) {
                                var name = _a[0], synth = _a[1];
                                return __awaiter(_this, void 0, void 0, function () {
                                    var core, oracle, _b, _c, collateral, _d, _e, synthetic, _f, _g;
                                    return __generator(this, function (_h) {
                                        switch (_h.label) {
                                            case 0:
                                                core = MozartCoreV1Factory_1.MozartCoreV1Factory.connect(synth, this.signer);
                                                _c = (_b = IOracleFactory_1.IOracleFactory).connect;
                                                return [4 /*yield*/, core.getCurrentOracle()];
                                            case 1:
                                                oracle = _c.apply(_b, [_h.sent(), this.signer]);
                                                _e = (_d = TestTokenFactory_1.TestTokenFactory).connect;
                                                return [4 /*yield*/, core.getCollateralAsset()];
                                            case 2:
                                                collateral = _e.apply(_d, [_h.sent(), this.signer]);
                                                _g = (_f = SyntheticTokenV1Factory_1.SyntheticTokenV1Factory).connect;
                                                return [4 /*yield*/, core.getSyntheticAsset()];
                                            case 3:
                                                synthetic = _g.apply(_f, [_h.sent(), this.signer]);
                                                this.synths[name] = {
                                                    core: core,
                                                    oracle: oracle,
                                                    collateral: collateral,
                                                    synthetic: synthetic,
                                                };
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MozartArc.prototype.availableSynths = function () {
        return Object.values(this.synths);
    };
    MozartArc.prototype.openPosition = function (collateralAmount, borrowAmount, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Open, {
                                id: 0,
                                amountOne: collateralAmount,
                                amountTwo: borrowAmount,
                                addressOne: constants_1.AddressZero,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.borrow = function (positionId, collateralAmount, borrowAmount, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Borrow, {
                                id: positionId,
                                amountOne: collateralAmount,
                                amountTwo: borrowAmount,
                                addressOne: constants_1.AddressZero,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.repay = function (positionId, repaymentAmount, withdrawAmount, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Repay, {
                                id: positionId,
                                amountOne: repaymentAmount,
                                amountTwo: withdrawAmount,
                                addressOne: constants_1.AddressZero,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.liquidatePosition = function (positionId, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.Liquidate, {
                                id: positionId,
                                amountOne: 0,
                                amountTwo: 0,
                                addressOne: constants_1.AddressZero,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.transferOwnership = function (positionId, newOwner, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract, tx;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.operateAction(core_1.Operation.TransferOwnership, {
                                id: positionId,
                                amountOne: 0,
                                amountTwo: 0,
                                addressOne: newOwner,
                            }, overrides)];
                    case 2:
                        tx = _a.sent();
                        return [4 /*yield*/, this.parseActionTx(tx)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.setGlobalOperatorStatus = function (operator, status, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.setGlobalOperatorStatus(operator, status, overrides)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.setPositionOperatorStatus = function (positionId, operator, status, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (overrides === void 0) { overrides = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var contract;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCore(synth, caller)];
                    case 1:
                        contract = _a.sent();
                        return [4 /*yield*/, contract.setPositionOperatorStatus(positionId, operator, status, overrides)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.getLiquidationDetails = function (position, synth) {
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        return __awaiter(this, void 0, void 0, function () {
            var currentPrice, fees, collateralRatio, borrowIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, synth.oracle.fetchCurrentPrice()];
                    case 1: return [4 /*yield*/, (_a.sent()).value];
                    case 2:
                        currentPrice = _a.sent();
                        return [4 /*yield*/, synth.core.getFees()];
                    case 3: return [4 /*yield*/, _a.sent()];
                    case 4:
                        fees = _a.sent();
                        return [4 /*yield*/, synth.core.getCollateralRatio()];
                    case 5: return [4 /*yield*/, (_a.sent()).value];
                    case 6:
                        collateralRatio = _a.sent();
                        return [4 /*yield*/, synth.core.getBorrowIndex()];
                    case 7:
                        borrowIndex = _a.sent();
                        return [2 /*return*/, calculations_1.calculateLiquidationAmount(position.collateralAmount.value, ArcNumber_1.default.bigMul(ethers_1.BigNumber.from(position.borrowedAmount.value), borrowIndex[0]), currentPrice, fees._liquidationUserFee.value, collateralRatio, fees._liquidationArcRatio.value)];
                }
            });
        });
    };
    MozartArc.prototype.parseActionTx = function (tx) {
        return __awaiter(this, void 0, void 0, function () {
            var receipt, decodedPosition, position, result;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tx.wait()];
                    case 1:
                        receipt = _a.sent();
                        decodedPosition = {};
                        receipt.logs.forEach(function (log) {
                            try {
                                var decoded = _this.availableSynths()[0].core.interface.decodeEventLog('ActionOperated', log.data, log.topics);
                                Object.entries(decoded).forEach(function (_a) {
                                    var key = _a[0], value = _a[1];
                                    decodedPosition[key] = value;
                                });
                            }
                            catch (_a) { }
                        });
                        position = {
                            owner: decodedPosition.updatedPosition[0],
                            collateralAmount: {
                                sign: decodedPosition.updatedPosition[1][0],
                                value: decodedPosition.updatedPosition[1][1],
                            },
                            borrowedAmount: {
                                sign: decodedPosition.updatedPosition[2][0],
                                value: decodedPosition.updatedPosition[2][1],
                            },
                        };
                        result = {
                            operation: decodedPosition.operation,
                            params: {
                                id: decodedPosition.params[0],
                                amountOne: decodedPosition.params[1],
                                amountTwo: decodedPosition.params[2],
                            },
                            updatedPosition: position,
                        };
                        return [2 /*return*/, result];
                }
            });
        });
    };
    MozartArc.prototype.approveSynthetic = function (amount, caller, synth, spender, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        if (spender === void 0) { spender = synth.core.address; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, approve_1.approve(amount, synth.synthetic.address, spender, caller, overrides)];
            });
        });
    };
    MozartArc.prototype.approveCollateral = function (amount, caller, synth, overrides) {
        if (caller === void 0) { caller = this.signer; }
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, approve_1.approve(amount, synth.collateral.address, synth.core.address, caller, overrides)];
            });
        });
    };
    MozartArc.prototype.isCollateralized = function (positionId, synth) {
        if (synth === void 0) { synth = this.availableSynths()[0]; }
        return __awaiter(this, void 0, void 0, function () {
            var position, price;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, synth.core.getPosition(positionId)];
                    case 1:
                        position = _a.sent();
                        return [4 /*yield*/, synth.core.getCurrentPrice()];
                    case 2:
                        price = _a.sent();
                        return [4 /*yield*/, synth.core.isCollateralized(position, price)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MozartArc.prototype.getCore = function (synth, caller) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, MozartCoreV1Factory_1.MozartCoreV1Factory.connect(synth.core.address, caller || this.signer)];
            });
        });
    };
    return MozartArc;
}());
exports.MozartArc = MozartArc;
exports.default = MozartArc;
//# sourceMappingURL=MozartArc.js.map